export const phishing = "gSa";
export default {phishing};